export default __webpack_public_path__ + "static/media/ic-banner-share.8857b2b7.svg";